var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.281,
    height: 24.617,
    viewBox: "0 0 23.281 24.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Bag",
    "data-name": "Iconly/Light-Outline/Bag",
    transform: "translate(-1.898 -1.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bag",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M11.525,0a5.981,5.981,0,0,1,5.938,5.348h.088c1.709,0,3.786,1.135,4.487,4.317l.93,7.2a6.659,6.659,0,0,1-1.242,5.522,6.721,6.721,0,0,1-5.275,2.033H6.613c-2.525,0-4.284-.619-5.379-1.89S-.233,19.34.142,16.844l.914-7.1c.6-3.256,2.8-4.394,4.5-4.394A5.974,5.974,0,0,1,11.5,0ZM17.55,7.117H5.556c-.52,0-2.256.21-2.755,2.9l-.91,7.07c-.3,1.983-.067,3.418.681,4.287s2.061,1.275,4.04,1.275H16.45a5.171,5.171,0,0,0,3.939-1.422,5.015,5.015,0,0,0,.827-4.126L20.3,9.97C19.907,8.213,18.875,7.117,17.55,7.117ZM14.961,10.4a.908.908,0,0,1,.911.884.861.861,0,0,1-.857.884h-.054a.884.884,0,0,1,0-1.767Zm-6.87,0A.908.908,0,0,1,9,11.281a.862.862,0,0,1-.858.884H8.092a.884.884,0,1,1,0-1.767Zm3.43-8.63H11.5A4.2,4.2,0,0,0,7.34,5.349h8.342A4.213,4.213,0,0,0,11.521,1.768Z",
    transform: "translate(0 0)",
    fill: "#fe2e1c",
    stroke: "#fe2e1c",
    strokeWidth: 0.2,
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopBag);
export default __webpack_public_path__ + "static/media/shop-bag.e3d1f703225477297ff7e8da438e894a.svg";
export { ForwardRef as ReactComponent };